
export let highlightedItem = () => {
	// Create container
	let container = document.createElement('div');
	container.classList.add('pulse-container');

	// Create three pulsing circles
	for (let i = 0; i < 3; i++) {
		let circle = document.createElement('div');
		circle.classList.add('pulse-circle');
		container.appendChild(circle);
	}

	return container;
}

export let gpsPulsingDot = () => {
	let pulsingDot = document.createElement('div');
	pulsingDot.classList.add('gps-pulsing-dot');
	let dot = document.createElement('span');
	dot.classList.add('gps-dot');
	pulsingDot.appendChild(dot);
	// let circle = document.createElement('span');
	// circle.classList.add('gps-circle');
	// pulsingDot.appendChild(circle);
	return pulsingDot;
}

